import {MENU_ROUTES} from '../actionType';

export default function (state={},action){
    switch (action.type) {
        case MENU_ROUTES:
            return {
                ...state,
                menuRoutes: action.data,
            };
        default:
            return state;
    }
}
